import React from 'react';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-28 pb-16 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="max-w-7xl mx-auto section-padding">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Transform Your Business with our
            <span className="text-primary-600 block">Digital solutions</span> 
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
            We specialize in creating custom web applications, reliable notion workspace solutions, 
            and professional email templates that help your business thrive in the digital world.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollToSection('services')}
              className="btn-primary"
            >
              Explore Our Services
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="btn-secondary"
            >
              View Products
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
